import { PlusOutlined } from '@ant-design/icons';
import { COLORS } from 'helpers/constants';
import { TPlusProps } from './type';

export const PlusAction = ({ style, onCustomClick, ...props }: TPlusProps) => (
  <PlusOutlined
    style={{ cursor: 'pointer', fontSize: '16px', color: COLORS.PRIMARY.BLUE, ...style }}
    onClick={(event) => {
      if (onCustomClick) {
        event.stopPropagation();
        onCustomClick?.();
      }
    }}
    {...props}
  />
);
